import { EquipmentCategoryData } from "@/features/equipmentModels/types/equipmentCategories";
import { ArrowBigRight } from "lucide-react";
import { Link } from "react-router-dom";
import Button from "../../../common/components/Button";

export class EquipmentCategoriesTransformer {
  static tableTransformer(operationKlassToCheckPermission?: string) {
    return (equipmentCategories: EquipmentCategoryData[]) => {
      return equipmentCategories.map((equipmentCategory) => ({
        ...equipmentCategory,
        display_name: (
          <p className="text-wrap">{equipmentCategory.display_name}</p>
        ),
        actions: (
          <Link to={`/equipment-categories/${equipmentCategory.id}`}>
            <Button
              name="access_equipment_categories_list"
              className="bg-transparent hover:bg-transparent p-0"
              operationKlassToCheckPermission={operationKlassToCheckPermission}
            >
              <ArrowBigRight />
            </Button>
          </Link>
        ),
      }));
    };
  }

  static quickSearchModelTransformer() {
    return (equipmentCategories: EquipmentCategoryData[]) => {
      return equipmentCategories.map((equipmentCategory) => ({
        route: `/equipment-categories/${equipmentCategory.id}`,
        items: [["Nome", equipmentCategory.display_name]],
      }));
    };
  }
}
